import React from 'react'
import Title from '../title/Title'
import brainstorming from '../../assets/png/brainstorming.png'
import presentation from '../../assets/png/presentation.png'
import goals from '../../assets/png/goals.png'
import launching from '../../assets/png/launching.png'

const options = [{text:'Brainstorming session', img:brainstorming ,click: true}, {img:presentation,  text:'Presentation Session'}, {img:goals, text:'Setting Goals Session'}, {img:launching, text:'Launching Session'}]
export default function Landing({nextPage}) {
    return (
        <div className="landing">
            <div className="searchHolder">

            
               <label className="searchIcon" >


                <input className="searchInput disabled" readOnly = {true} type="text" placeholder="Search" />
        </label>
        </div>
                  <Title title="Good Morning!" subtitle="How do you want to show up today?"/> 
            <div className="sectionDivider">
            Recently Viewed Courses
            </div>
            <div className="options">
                {options.map(el => <div className="option">
                    <div onClick={el.click? () =>nextPage(1): ''} className={"button hoverImage "+ (el.text === 'Place holder text'?'disabled': '')}>
                    <img src={el.img} alt=""/>
                    </div>
                    <p>{el.text}</p>
                    </div>)}
            </div>
        </div>
    )
}
